import React, { useContext, useState, useEffect } from "react";
import styles from "./index.module.scss";
import { Badge } from "react-bootstrap";
import { Row, Col } from "react-flexbox-grid";
import { SquadContext } from "../../providers/SquadProvider";
import { SettingsContext } from "../../providers/SettingsProvider";
import { getCurrentRoundPts } from "../../helpers/squad";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getAllowedTransfers, getMonthLabel } from "../../helpers/user";
import "dayjs/locale/uk";

dayjs.locale("uk");

const InfoPanel = () => {
  const [allowedTransfersText, setAllowedTransfersText] = useState("");

  const {
    squad,
    squadSnapshot,
    teamBalance,
    allowedTransfers,
    squadScores,
  } = useContext(SquadContext);

  const {
    activeDeadline,
    roundDeadline,
    monthIndex,
    currentRound,
    mainInfo,
    monthInfo,
    prevRoundInfo,
    leagueInfo,
    prevMonth,
    prevLeague,
    prevMain,
  } = useContext(SettingsContext);

  const navigate = useNavigate();

  useEffect(() => {
    const allowedTransfersText = getAllowedTransfers(allowedTransfers);
    setAllowedTransfersText(allowedTransfersText);
  }, [allowedTransfers, squad, squadSnapshot]);

  const currentRoundPts = getCurrentRoundPts(squadScores);

  const goToStandings = () => {
    navigate("/standings/-1");
  };

  const monthDiff = prevMonth?.Rank - monthInfo?.Rank;
  const leagueDiff = prevLeague?.Rank - leagueInfo?.Rank;
  const mainDiff = prevMain?.Rank - mainInfo?.Rank;

  return (
    <Row>
      <Col md={6} xs={12}>
        <div className={styles.panel}>
          <div className={styles.col}>
            <span className={styles.caption}>
              {activeDeadline ? "Дедлайн туру" : "Поточний тур"}
            </span>
            <Badge
              onClick={() =>
                !activeDeadline && navigate(`/standings/${currentRound}`)
              }
              className={`${styles.badge} ${
                !activeDeadline ? styles.hoverable : null
              }`}
              style={{
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
              }}
              bg={activeDeadline ? "success" : "danger"}
            >
              {activeDeadline ? (
                dayjs(roundDeadline).format("DD MMM HH:mm")
              ) : (
                <>
                  <div>LIVE</div>
                  <div className={styles.points}>{currentRoundPts}</div>
                </>
              )}
            </Badge>
          </div>

          <div className={styles.col}>
            <span className={styles.caption}>Баланс/Трансфери</span>
            <Badge
              className={styles.badge}
              bg="success"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>{teamBalance?.toFixed(1)}$</div>
              <div className={styles.points}>{allowedTransfersText}</div>
            </Badge>
          </div>
          <div className={styles.col} style={{ marginRight: 0 }}>
            <span className={styles.caption}>Минулий тур</span>
            <Badge
              className={`${styles.badge} ${styles.hoverable} ${styles.left}`}
              style={{ color: "#fff" }}
              bg="success"
              onClick={() => navigate(`/standings/${currentRound - 1}`)}
            >
              {prevRoundInfo?.Rank}/{prevRoundInfo?.All || "-"}
              <div className={styles.points}>
                {prevRoundInfo?.Points || "-"}
              </div>
            </Badge>
          </div>
          <div className={styles.divider}></div>
        </div>
      </Col>
      <Col md={6} xs={12}>
        <div
          className={styles.panel}
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <div className={styles.col}>
            <div className={styles.labelCnt}>
              <span className={styles.caption}>
                {getMonthLabel(monthIndex) || "Mісяць"}
              </span>
              {prevMonth && monthDiff !== 0 && (
                <div
                  className={styles.diff}
                  style={{ color: monthDiff > 0 ? "green" : "red" }}
                >
                  <i
                    className={`bi bi-caret-${
                      monthDiff > 0 ? "up" : "down"
                    }-fill`}
                  ></i>
                  <span>{monthDiff}</span>
                </div>
              )}
            </div>
            <Badge
              className={`${styles.badge} ${styles.hoverable} ${styles.left}`}
              style={{ color: "#fff" }}
              bg="success"
              onClick={() => navigate(`/standings/${monthIndex}`)}
            >
              {monthInfo?.Rank || "-"}/{monthInfo?.All || "-"}
              <div className={styles.points}>{monthInfo?.Points || "-"}</div>
            </Badge>
          </div>

          <div className={styles.col}>
            <div className={styles.labelCnt}>
              <span className={styles.caption}>Ліга</span>
              {prevLeague && leagueDiff !== 0 && (
                <div
                  className={styles.diff}
                  style={{ color: leagueDiff > 0 ? "green" : "red" }}
                >
                  <i
                    className={`bi bi-caret-${
                      leagueDiff > 0 ? "up" : "down"
                    }-fill`}
                  ></i>
                  <span>{leagueDiff}</span>
                </div>
              )}
            </div>
            <Badge
              className={`${styles.badge} ${styles.hoverable} ${styles.left}`}
              bg="success"
              style={{ color: "#fff" }}
              onClick={() => navigate("/leagues")}
            >
              {leagueInfo?.Rank || "-"}/{leagueInfo?.All || "-"}
              <div className={styles.points}>{leagueInfo?.Points || "-"}</div>
            </Badge>
          </div>

          <div className={styles.col} style={{ marginRight: 0 }}>
            <div className={styles.labelCnt}>
              <span className={styles.caption}>Сезон</span>
              {prevMain && mainDiff !== 0 && (
                <div
                  className={styles.diff}
                  style={{ color: mainDiff > 0 ? "green" : "red" }}
                >
                  <i
                    className={`bi bi-caret-${
                      mainDiff > 0 ? "up" : "down"
                    }-fill`}
                  ></i>
                  <span>{mainDiff}</span>
                </div>
              )}
            </div>
            <Badge
              className={`${styles.badge} ${styles.hoverable} ${styles.left}`}
              bg="success"
              onClick={goToStandings}
              style={{ color: "#fff" }}
            >
              {mainInfo?.Rank || "-"}/{mainInfo?.All || "-"}
              <div className={styles.points}>{mainInfo?.Points || "-"}</div>
            </Badge>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default InfoPanel;
